import { render } from "./Order.vue?vue&type=template&id=3c754980&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=3c754980&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c754980"

export default script